import styled from "styled-components";
import {
  Button as AntButton,
  Typography,
  Form as AntForm,
  Input as AntInput,
  Divider as AntDivider,
} from "antd";
import { AuthHeadingBg } from "@assets/auth";
import lightTheme from "@styles/theme";
import { AuthArrow } from "@assets";

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }
  position: relative;
`;

export const Heading = styled.div`
  width: 100%;
  height: 300px;
  background-image: url(${AuthHeadingBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: center;
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: ${(props) => (props.backKey ? "end" : "space-between")};
  align-items: center;
  height: 37px; /* need to add this to be the same height with nav from other auth pages */
  margin: 24px 0 0 0;
`;

export const ArrowIconWrapper = styled.div`
  margin: 0 0 0 20px;
  width: 36px;
  height: 36px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  cursor: pointer;
`;
export const BackIcon = styled(AuthArrow)`
  width: 25px;
  height: 25px;
`;

export const SkipButton = styled(AntButton)`
  display: inline-flex;
  padding: 8px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 12px;
  margin: 0 20px 0 0;

  color: #ffffff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Title = styled(Typography.Title)`
  font-family: 'Lato';
  color: #000000 !important;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-align: center;
  margin: 250px 0 0px ;
`;

export const ContentContainer = styled.div`
  width: calc(100% - 32px);
  margin: 50px auto 24px;
  padding: 10px 16px 0;
`;

export const Form = styled(AntForm)`
  margin: 5px 0 0 0;
  width: 100%;
  text-align: center;

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    margin-left: 8px;
    text-align: center;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #004f9c;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;
export const Input = styled(AntInput)`
  -moz-appearance: textfield;
  padding-left: 16px;
  height: 56px;
  border-radius: 26px;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #000;
  background: #fff;
  text-align: center;
  border: 1px solid #0095DA !important;
  margin-bottom: 5px;

  &::placeholder {
    color: #0000004d;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const TextButton = styled(AntButton)`
  float: right;
  text-align: right;
  color: #004F9C;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin: -25px 0 0 0;
`;

export const Divider = styled(AntDivider)`
  padding: 0px 0px 12px 0px;
  .ant-divider-inner-text {
    font-size: 12px;
    font-weight: 400;
    color: #004F9C;
  }

  ::before,
  ::after {
    border: 1px solid #DEEDFF;
    border-color: #DEEDFF !important;
  }
`;

export const LoginButton = styled(AntButton)`
  color: #13100f;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 7px 0 0 0;
`;

export const RegisterButton = styled(AntButton)`
  margin: 0 0 20px;
  border-radius: 26px !important;
  background: #EDAD0C !important;

  color: #000;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  &:hover {
    color: #000 !important;
    background: #EDAD0C !important;
  }
`;

export const ContinueButton = styled(AntButton)`
  background: ${(props) =>
    props.disabled
      ? "#E1F0FF"
      : "#0095DA"} !important;
  border: none !important;
  border-radius: 26px !important;
  &:disabled {
    color: #1E1E1E !important;
  }
`;

export const GoToPromoRegisterButton = styled(ContinueButton)`
`

export const OrText = styled.p`
  text-align: center;
  margin: 24px 0;

  color: #000;
  font-size: 16px;
  font-weight: 700;
  line-height: normal;
`


export const TelegramLoginButton = styled.div`
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 24px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SocialLoginWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
width: 100%;
height: 52px;
border-radius: 24px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background: ${props => props.theme.buttonColor};
cursor: pointer;
position: relative;

font-size: 16px;
font-weight: bold;
color: #fff;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;